import WindowCommands from "./WindowCommands";

export default WindowCommands;
